import * as React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import { AscendState } from '../../../ducks';
import { CLEAR_ERRORS } from '../../../ducks/actions';
import { errorMessagesSelector } from '../../../ducks/error';
import { connect, Dispatch } from 'react-redux';
import './ErrorSnackbar.css';

interface ErrorSnackbarProps {
  errors: string[];
  clearErrors: () => void;
}

const displayMessages = (errors: string[]) => (
  <div id="message-id">
    {errors.map((err) => (
      <div key={err}>
        {err}
        <br />
      </div>
    ))}
    Please contact us at{' '}
    <a className="ErrorSnackbar-email-link" href="mailto:support@tryascend.com">
      support@tryascend.com
    </a>{' '}
    for more information.
  </div>
);

const ErrorSnackbar = ({ errors, clearErrors }: ErrorSnackbarProps) => (
  <Snackbar
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    open={errors.length > 0}
    message={displayMessages(errors)}
    action={[
      <IconButton key="close" aria-label="Close" color="inherit" onClick={() => clearErrors()}>
        <CloseIcon />
      </IconButton>,
    ]}
  />
);

const mapStateToProps = (state: AscendState) => ({
  errors: errorMessagesSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});
export default connect(mapStateToProps, mapDispatchToProps)(ErrorSnackbar);
